module.exports = __webpack_public_path__ + "img/CZ.6f3e9904.svg";